// @flow

import moment from 'moment';

import type { Shift } from '../../common/typings';
import { getRealDate, formatTime, toDateShort } from '../../utils/Utils';

export default function getUpcomingShiftDescription(shift: Shift, usTimeFormat: boolean): string {
  if (isToday(shift.dtstart)) {
    return `Your next shift starts at ${formatTime(getRealDate(shift.dtstart), usTimeFormat)}`;
  }
  return `Your next shift starts on ${toDateShort(shift.dtstart, usTimeFormat)} at ${formatTime(
    getRealDate(shift.dtstart),
    usTimeFormat
  )}`;
}

function isToday(date: Date): boolean {
  return moment().isSame(date, 'day');
}
